export const adminNotificationTypes = ['administration', 'report'];
